import { render } from "./LayoutPriceFrom.vue?vue&type=template&id=5feaff20&scoped=true"
import script from "./LayoutPriceFrom.vue?vue&type=script&lang=js"
export * from "./LayoutPriceFrom.vue?vue&type=script&lang=js"

import "./LayoutPriceFrom.vue?vue&type=style&index=0&id=5feaff20&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5feaff20"]])

export default __exports__